<template>
  <div style="display: flex;">
    <click-to-edit
      v-model="value.card_scale.template_id"
      style="width:100%"
      type="select"
      :disabled="disabled"
      placeholder=""
      select-filterable
      :select-options="templates"
      select-option-id="id"
      select-option-name="name"
      select-cast-value-to-int
      @opened="loadTemplates"
      @input="changed"
    >
    </click-to-edit>
    <cascading-card-scale-template-edit-modal
      v-if="!disabled"
      :template.sync="value.card_scale"
      style="margin-left: 5px"
    >
      <el-button
        slot="reference"
        size="small"
        type=""
        plain
        icon="fas fa-pen"
        @click="setCustomScale()"
      ></el-button>
    ></cascading-card-scale-template-edit-modal>
  </div>

</template>

<script>
import ClickToEdit from "@/components/ClickToEdit.vue";
import CascadingCardScaleTemplateEditModal
  from "@/modules/cascading/components/cardScale/CascadingCardScaleTemplateEditModal.vue";
import CascadingQualityScaleTemplateEditModal
  from "@/modules/cascading/components/scale/CascadingQualityScaleTemplateEditModal.vue";

export default {
  name: "CascadingCardScaleSelect",
  components: { CascadingQualityScaleTemplateEditModal, CascadingCardScaleTemplateEditModal, ClickToEdit},
  props: {
    value: {}, // whole element
    disabled: {type: Boolean, default: false},
  },

  watch: {
    'value.card_scale': function (newVal) {
      this.initSelect();
    },
  },
  mounted() {
    this.initSelect();
  },
  data() {
    return {
      templates: [],
    }
  },
  methods: {
    initSelect(){
      this.templates = [];
      if( this.value?.card_scale?.template ){
        this.templates.push({id:this.value.card_scale.template.id, name: this.value.card_scale.template.name});
      }
      this.addCustomScaleToList();
    },

    loadTemplates() {
      this.$api.cascading.getCardScaleTemplates()
        .then(data => {
          this.templates = data.templates;
          this.addCustomScaleToList();
        })
    },
    addCustomScaleToList(){
      this.templates.push({id: 0, name: this.value.card_scale.name})
    },
    setCustomScale(){
      this.value.card_scale.template_id = 0;
      this.changed();
    },
    changed() {
      this.$emit('input', this.value);
      this.$emit('change', this.value)
    }
  },

}
</script>
